export const sanityCategoryIdToUrn = (sanityId: string) => {
  return sanityId.replace('urn-category-', 'urn:category:');
};
